import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
//shokor
export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        
        {/* Column 1: Core App Links */}
        <div className="footer-col">
          <h4>Talkvee</h4>
          <Link to="/">Home</Link>
          <Link to="/ranking">Leaderboard</Link>
          <Link to="/about">About Us</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>

        {/* Column 2: High-Volume Keywords */}
        <div className="footer-col">
          <h4>Discover</h4>
          <Link to="/random-video-chat">Random Video Chat</Link>
          <Link to="/talk-to-strangers">Talk to Strangers</Link>
          <Link to="/meet-strangers-online">Meet Strangers Online</Link>
          <Link to="/video-chat-with-strangers">Video Chat with Strangers</Link>
          <Link to="/free-online-video-chat">Free Online Video Chat</Link>
        </div>

        {/* Column 3: Competitor Alternatives (The Big Growth Driver) */}
        <div className="footer-col">
          <h4>Alternatives</h4>
          {/* ✅ NEW: Targeting the biggest keyword in the industry */}
          <Link to="/omegle-alternative" style={{ fontWeight: 'bold', color: 'var(--tv-primary)' }}>
            Omegle Alternative
          </Link>
          <Link to="/chatroulette-alternative">Chatroulette Alternative</Link>
          <Link to="/azar-alternative">Azar Alternative</Link>
          <Link to="/coomeet-alternative">CooMeet Alternative</Link>
          <Link to="/ome-tv-alternative">OmeTV Alternative</Link>
          <Link to="/emerald-chat-alternative">Emerald Chat Alternative</Link>
          <Link to="/monkey-app-alternative">Monkey App Alternative</Link>
        </div>

        <div className="footer-col">
          <h4>Features & Games</h4>
          <Link to="/trivia-video-chat">Trivia Video Chat</Link>
          <Link to="/laugh-challenge-chat">Laugh Challenge</Link>
          <Link to="/tic-tac-toe-strangers">Tic-Tac-Toe Chat</Link>
          <Link to="/connect-4-video-chat">Connect 4 Chat</Link>
        </div>

        <div className="footer-col">
          <h4>Experience</h4>
          <Link to="/ad-free-video-chat">Ad-Free Chat</Link> 
          <Link to="/stranger-chat-no-login">No Login Chat</Link>
        </div>

      </div>
      
      <div className="footer-copyright">
        © {new Date().getFullYear()} Talkvee. A safer way to meet the world.
      </div>
    </footer>
  );
}